import { observable, set } from 'mobx';
import { pascalCaseData } from '~utils/CaseUtils';
import { formatLoyaltyLevel } from '~utils/FormatterUtils';
import { IBenefitsInfo } from '~views/dashboard/loyalty-benefits/ILoyaltyBenefits';
import {
    ILoyaltyBenefitsResponse,
    IOfferDetailsResponse
} from '~api/interfaces/ILoyaltyBenefitsResponse';
import { getSortedOffersInfo, PriorityOrderSort, CategoryOrderSort } from '~utils/OffersSorting';

class Benefits {
    @observable public benefitsDataFormatted: IBenefitsInfo[] = [];

    static fromJSON(benefitsData: ILoyaltyBenefitsResponse): Benefits {
        const benefitsOfferInfo = new Benefits();
        const { user: {benefits: offerData }, currentLoyaltyLevel } = benefitsData;

        const benefitsOfferFields = offerData || [];

        const filteredOfferFields = benefitsOfferFields?.filter(
            (levelDetails) =>
                currentLoyaltyLevel === '0' ||
                formatLoyaltyLevel(levelDetails?.criteria as string)?.includes(currentLoyaltyLevel)
        );

        const benefitsDataFormatted = filteredOfferFields?.map(
            (offerDetails: IOfferDetailsResponse) => ({
                inCart: offerDetails?.inCart,
                meetsCriteria: offerDetails?.meetsCriteria,
                offerButtonLabel: pascalCaseData(offerDetails?.promo?.text?.action as string, true),
                redeemedStatus: offerDetails?.promo?.text?.redeemed,
                offerCode: offerDetails?.offerCode,
                offerDescription: offerDetails?.promo?.text?.description,
                offerImage: offerDetails?.image,
                offerLinkAction: offerDetails?.promo?.URL?.action,
                offerPoints: offerDetails?.points,
                offerTitle: offerDetails?.promo?.text?.title,
                offerUsed: offerDetails?.used,
                offerView: '',
                skuID: '',
                subHeading: offerDetails?.promo?.text?.subHeading,
                benefits: JSON.parse(offerDetails?.benefits || '[]'),
                highestPriorityClass: null,
                criteriaViewValidations: offerDetails?.criteriaViewValidations,
                offerNotificationFields: {
                    criteriaFieldsList: offerDetails?.criteriaFields,
                    criteriaAllowedTierList: offerDetails?.criteriaAllowedTiers,
                    criteriaRequiredSkuList: offerDetails?.criteriaRequiredSkus,
                    pointsNeeded: offerDetails?.pointsNeeded
                }
            })
        );

        const modifiedData = {
            benefitsDataFormatted
        };

        set(benefitsOfferInfo, modifiedData);

        return benefitsOfferInfo;
    }

    public static getSortedBenefitsInfo(benefitsDataFormatted: IBenefitsInfo[], priorityOrder?: PriorityOrderSort[], categoryOrder?: CategoryOrderSort[]) {
        const benefitsOfferInfo = new Benefits();
        const modifiedData = {
            benefitsDataFormatted: getSortedOffersInfo(benefitsDataFormatted, priorityOrder, categoryOrder)
        };
        set(benefitsOfferInfo, modifiedData);

        return benefitsOfferInfo;
    }
}

export default Benefits;
